// Пресеты портретов профиля — только из набора игры, свою картинку загрузить нельзя.
// v1 — типографические плашки в палитре мира (глиф + цвет); при арт-заходе глифы
// заменятся на отрисованные портреты тех же персонажей, id сохраняются.

export interface AvatarPreset {
  id: string;
  /** подпись под пресетом и alt */
  name: string;
  /** глиф-заглушка до арта */
  glyph: string;
  /** цвет плашки (пергаментная палитра) */
  color: string;
}

export const AVATARS: AvatarPreset[] = [
  { id: 'zhitel',   name: 'Житель',     glyph: 'Ж', color: '#B26A33' }, // оранжевый куб-путник
  { id: 'delta',    name: 'Дельта',     glyph: 'Δ', color: '#2E8C74' },
  { id: 'bagnar',   name: 'Багнар',     glyph: 'Б', color: '#8F3B2C' },
  { id: 'strazh',   name: 'Страж',      glyph: 'С', color: '#6E6353' },
  { id: 'hardkod',  name: 'Хардкод',    glyph: 'Х', color: '#1E1A14' },
  { id: 'portal',   name: 'Портал',     glyph: 'П', color: '#1F5F4E' },
  { id: 'tramplin', name: 'Трамплин',   glyph: 'Т', color: '#A08453' },
  { id: 'venti',    name: 'Вентилятор', glyph: 'В', color: '#587B8C' },
];

export function avatarById(id: string): AvatarPreset {
  return AVATARS.find((a) => a.id === id) ?? AVATARS[0];
}
